/**************
 Global
 ***************/

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    return fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//change an existing product in your cart
//let formData = { quantity: 1, id: 794864229 } or items: [{ quantity: 1, id: 794864229 }]
function changeCart(formData) {
    return fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//update cart note or attributes (_ for attributes are hidden and __ are private)
//let formData = { note: 'This is a note about my order', attributes: { 'Gift wrap': 'Yes' } }
//let formData = {updates: { 794864229: 2, 794864230: 3 }}
function updateCart(formData) {
    return fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

// download product
function downloadProduct(handle) {
    return fetch(`${Shopify.routes.root}products/${handle}.js`)
        .then(data => data.json());
}

// get cart
function getCart() {
    return fetch(`${Shopify.routes.root}cart.js`)
        .then(data => data.json());
}

// print price (515491 => $5,154.91)
function price(amountInCents, removeTrailingZeros = false) {
    // calculate total
    let total = (parseFloat(amountInCents) / 100).toFixed(2).toString();

    // add commas if needed
    total = total.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // remove trailing zeros
    if (removeTrailingZeros) {
        total = total.toString().replace(".00", "");
    }

    // return total
    return `${currency}${total}`;
}

// sleep
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

/**************
 Design mode open mini cart
 ***************/
if (Shopify.designMode) {
    // if a user clicks on the mini cart
    document.addEventListener('shopify:section:select', function (event) {
        // open mini cart
        if (event.detail.sectionId === 'theme-mini-cart') {
            openCart();
        }

        // if they deselect the mini cart
        if (event.detail.sectionId !== 'theme-mini-cart') {
            closeCart();
        }
    });
}

// scroll to url hash
const maltertechParams = new URLSearchParams(window.location.search);

if (maltertechParams.get("scroll_to_class")) {
    const element = document.querySelector(`.${maltertechParams.get("scroll_to_class")}`);
    if (element) {
        window.scrollTo({
            behavior: 'smooth',
            top: element.offsetTop - 120,
        })
    }
}

if (maltertechParams.get("scroll_to_id")) {
    const element = document.querySelector(`#${maltertechParams.get("scroll_to_id")}`);
    if (element) {
        window.scrollTo({
            behavior: 'smooth',
            top: element.offsetTop - 120,
        })
    }
}

// Function to send back in stock subscription to Klaviyo
async function sendKlaviyoBackInStockRequest(emailAddress, variantID) {
    await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${await klaviyo.account()}`, {
        method: 'POST',
        headers: {
            accept: 'application/vnd.api+json',
            revision: '2024-10-15',
            'content-type': 'application/vnd.api+json'
        },
        body: JSON.stringify({
            data: {
                type: "back-in-stock-subscription",
                attributes: {
                    channels: ["EMAIL"],
                    profile: {
                        data: {
                            type: "profile",
                            attributes: {
                                email: emailAddress,
                            }
                        }
                    }
                },
                relationships: {
                    variant: {
                        data: {
                            type: "catalog-variant",
                            id: `$shopify:::$default:::${variantID}`,
                        }
                    }
                }
            }
        })
    })
}


/*****
 * Stars Function
 */

//function for generating stars
function stars(rating) {
    let HTML = "";

    // add full stars
    for (let i = 0; i < Math.floor(rating); i++) {
        HTML += `<svg width="36" height="33" viewBox="0 0 36 33" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M7.60994 30.7752C7.54559 31.1504 7.69981 31.5295 8.00776 31.7533C8.3157 31.977 8.72396 32.0065 9.06088 31.8294L18.0003 27.1298L26.9397 31.8294C27.2766 32.0065 27.6848 31.977 27.9928 31.7533C28.3007 31.5295 28.4549 31.1504 28.3906 30.7752L26.6833 20.8213L33.9154 13.7718C34.188 13.5061 34.2861 13.1087 34.1685 12.7467C34.0509 12.3847 33.7379 12.1209 33.3612 12.0661L23.3667 10.6139L18.897 1.55743C18.7285 1.2161 18.3809 1 18.0003 1C17.6196 1 17.272 1.2161 17.1035 1.55743L12.6338 10.6139L2.63931 12.0661C2.26262 12.1209 1.94968 12.3847 1.83205 12.7467C1.71443 13.1087 1.81253 13.5061 2.0851 13.7718L9.3172 20.8213L7.60994 30.7752Z" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/> </svg>`;
    }

    // add partial star if it's not a integer
    if (Number.isInteger(rating) == false) {
        let remainder = rating * 100 - Math.floor(rating) * 100;
        HTML += `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="2.79 3.4 18.42 17.67"> <path d="M6.50929 19.3369C6.45781 19.637 6.58119 19.9404 6.82754 20.1193C7.0739 20.2983 7.40051 20.3219 7.67004 20.1802L12.0001 17.9038L16.3302 20.1802C16.5998 20.3219 16.9264 20.2983 17.1727 20.1193C17.4191 19.9404 17.5425 19.637 17.491 19.3369L16.664 14.5154L20.1671 11.1007C20.3852 10.8882 20.4637 10.5703 20.3696 10.2807C20.2755 9.99104 20.0251 9.77997 19.7237 9.73618L14.8826 9.03272L12.7175 4.64594C12.5828 4.37288 12.3046 4.2 12.0001 4.2C11.6956 4.2 11.4175 4.37288 11.2827 4.64594L9.1177 9.03272L4.27652 9.73618C3.97517 9.77997 3.72481 9.99104 3.63071 10.2807C3.53661 10.5703 3.61509 10.8882 3.83315 11.1007L7.33626 14.5154L6.50929 19.3369Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"></path> <mask id="mask0_1237_4957" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="3" y="3" width="18" height="18"> <path d="M6.70641 19.3707C6.6678 19.5958 6.76033 19.8233 6.9451 19.9575C7.12987 20.0918 7.37482 20.1095 7.57697 20.0032L12.0001 17.6779L16.4233 20.0032C16.6254 20.1095 16.8704 20.0918 17.0552 19.9575C17.2399 19.8233 17.3325 19.5958 17.2939 19.3707L16.4491 14.4455L20.0275 10.9575C20.1911 10.7981 20.2499 10.5597 20.1793 10.3425C20.1088 10.1252 19.921 9.96694 19.695 9.9341L14.7498 9.21553L12.5382 4.73446C12.4371 4.52966 12.2285 4.4 12.0001 4.4C11.7717 4.4 11.5632 4.52966 11.4621 4.73446L9.25052 9.21553L4.30528 9.9341C4.07926 9.96694 3.89149 10.1252 3.82092 10.3425C3.75035 10.5597 3.80921 10.7981 3.97275 10.9575L7.55115 14.4455L6.70641 19.3707Z" fill="currentColor" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"></path> </mask> <g mask="url(#mask0_1237_4957)"> <rect x="3.27271" y="3.54544" width="${remainder + "%"}" height="17.4545" fill="currentColor"></rect> </g> </svg>`;
    }

    // add empty stars
    for (let i = 0; i < 5 - Math.ceil(rating); i++) {
        HTML += `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="2.79 3.4 18.42 17.67"><path d="M6.50929 19.3369C6.45781 19.637 6.58119 19.9404 6.82754 20.1193C7.0739 20.2983 7.40051 20.3219 7.67004 20.1802L12.0001 17.9038L16.3302 20.1802C16.5998 20.3219 16.9264 20.2983 17.1727 20.1193C17.4191 19.9404 17.5425 19.637 17.491 19.3369L16.664 14.5154L20.1671 11.1007C20.3852 10.8882 20.4637 10.5703 20.3696 10.2807C20.2755 9.99104 20.0251 9.77997 19.7237 9.73618L14.8826 9.03272L12.7175 4.64594C12.5828 4.37288 12.3046 4.2 12.0001 4.2C11.6956 4.2 11.4175 4.37288 11.2827 4.64594L9.1177 9.03272L4.27652 9.73618C3.97517 9.77997 3.72481 9.99104 3.63071 10.2807C3.53661 10.5703 3.61509 10.8882 3.83315 11.1007L7.33626 14.5154L6.50929 19.3369Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"></path></svg>`;
    }

    return HTML;
}


// collection cards
document.querySelectorAll('.collectionItem')?.forEach(item => {

    // nutrition dropdown
    item.querySelector('.collectionItemNutritionButton').addEventListener('click', function () {
        this.classList.toggle('active')
    });

    // quick add to cart
    item.querySelector('.collectionItemATC').addEventListener('click', async function () {
        this.classList.add('loading');

        await addProduct({
            items: [{
                quantity: 1,
                id: this.dataset.id
            }]
        })

        this.classList.remove('active');
    });

})